export const callManagementConstants = {
    CALL_MANAGEMENT_REQUEST: 'CALL_MANAGEMENT_REQUEST',
    CALL_MANAGEMENT_GET_SUCCESS: 'CALL_MANAGEMENT_GET_SUCCESS',
    CALL_MANAGEMENT_FAILURE: 'CALL_MANAGEMENT_FAILURE', 
    DELETE_CALL_MANAGEMENT_SUCCESS : 'DELETE_CALL_MANAGEMENT_SUCCESS',
    EXPORT_CALL_MANAGEMENT_REQUEST: 'EXPORT_CALL_MANAGEMENT_REQUEST',
    EXPORT_CALL_MANAGEMENT_SUCCESS: 'EXPORT_CALL_MANAGEMENT_SUCCESS',
    EXPORT_CALL_MANAGEMENT_FAILURE: 'EXPORT_CALL_MANAGEMENT_FAILURE',
}
